import { ru } from 'locale';

const options = [
  { label: ru.all, value: 'all' },
  { label: ru.draft, value: 'draft' },
  { label: ru.scoring, value: 'scoring' },
  { label: ru.contractEntry, value: 'contract' },
  { label: ru.scan, value: 'scan' },
  { label: ru.limit, value: 'limit' },
  { label: ru.done, value: 'done' },
  { label: ru.archived, value: 'archived' },
  { label: ru.upd_down, value: 'upd_down' },
  { label: ru.rescore, value: 'rescore' },
  { label: ru.actionRequired, value: 'action_required' },
];

export default options;
